import { RouteType } from "types/RouteType";
import clientsRoute from "./ClientList/clients.Route";
import clientDetailRoute from "./ClientDetail/clientDetail.Route";
import clientRiskRoute from "./ClientRisk/clientRisk.Route";
import clientInquiriesRoute from "./ClientInquiries/clientInquiries.Route";
import inquiryQueueRoute from "./InquiryQueue/inquiryQueue.Route";
import myQuestionsRoute from "./InquiryQueue/myQuestions.Route";
import contractsRoute from "./Contracts/contracts.Route";
import onboardingRoute from "./Onboarding/onboarding.Route";

/**
 * ORDER IS LOAD-BEARING. The URL matcher is first-match, and ClientDetail's
 * `/clients/:id/:tab?` swallows `/clients/risk` (`:id` = "risk"), which rendered
 * the detail view's "Client not found" on every /clients/risk deep link. The
 * literal path must be registered BEFORE the parameterized one.
 */
const clientsRoutesList: RouteType[] = [
  ...clientsRoute,
  ...clientRiskRoute,
  ...clientInquiriesRoute,
  ...inquiryQueueRoute,
  ...myQuestionsRoute,
  // Blake's trackers (#3075 / #2663): literal paths, so before ClientDetail.
  ...contractsRoute,
  ...onboardingRoute,
  ...clientDetailRoute,
];

export default clientsRoutesList;
